export default "__VITE_ASSET__DZeNwElp__"